import { glAxiosRequest } from "../glAxios/glAxios";

export async function getFeaturedTitlesAPI() {
  return await glAxiosRequest("get", `/opac101/v1/assets/titles`);
}

export async function getNewsAPI() {
  return await glAxiosRequest("get", `/opac101/v1/assets/news`);
}
